<template>
    <div>Landing</div>
</template>

<script>
import DeliveryHelper from '@/helper/DeliveryHelper';
export default {
    created: function() {
        if (this.$route.params.targetPage && this.$route.params.targetPage == "selectbranch") {
            let selectBranch = {
                isSelectBranch: true
            }
            DeliveryHelper.setCacheSelectBranch(selectBranch);
            this.$router.replace("/");
        }
    },
}
</script>

<style>

</style>